import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';
import React from 'react';

const ContentItemAudienceCount = ({count, everyoneHasAccess}:{count:number, everyoneHasAccess: boolean}) => (
    <div className='audience-counter-content-list-wrapper'>
        <Icon iconName={IconLibrary.USERS} sizeInPx='12' color='#343D4C'/>
        <span className='audience-count-number'>{everyoneHasAccess ? "Everyone" : count}</span>
    </div>
)

export default ContentItemAudienceCount

